export default "__VITE_ASSET__db96de33__"